import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { createCompanyStatement, getCompanyStatement, site_settingsfindAll } from "../../../services/api";
import CommonTable from "../../../Helper/Table";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import logo from './../../../../src/assets/img/logo.png'
function CreateStatement() {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
   const navigate = useNavigate()
const [pagination, setPagination] = useState({
  page: 1,
  limit: 10
});
const [search, setSearch] = useState("");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [siteData, setSiteData] = useState(null);
const [paginationData, setPaginationData] = useState({
  totalPages: 1,
  currentPage: 1,
  totalRecords: 0
});
//  query params
const params = new URLSearchParams(location.search);
const shopNameFromParams = params.get("shopName");


const company = location.state?.company || {};

  const {  register, handleSubmit, watch,reset,formState: { errors }
  } = useForm({ defaultValues: {  date: new Date().toISOString().split("T")[0], particulars: "",type: "debit", credit: 0, debit: 0, refNo: "" }
});

  const type = watch("type");

const fetchData = async (
  page = pagination.page,
  limit = pagination.limit,
  customFilters = {}
) => {
  const payload = {
    companyId: company?.CompanyId,
    page,
    limit,
    search: customFilters.search ?? search,
    fromDate: customFilters.fromDate ?? fromDate,
    toDate: customFilters.toDate ?? toDate
  };

  const res = await getCompanyStatement(payload);

  if (res?.status) {
    setData(res.data || []);

    setPaginationData({
      totalPages: Math.ceil(res.total / limit),
      currentPage: page,
      totalRecords: res.total
    });

    setPagination({ page, limit });
  }
};
const handlePageChange = (newPage) => {
  fetchData(newPage, pagination.limit, {
    search,
    fromDate,
    toDate
  });
};
const handleLimitChange = (newLimit) => {
  setPagination({ page: 1, limit: newLimit });

  fetchData(1, newLimit, {
    search,
    fromDate,
    toDate
  });
};
useEffect(() => {
  if (company?.CompanyId) {
    fetchData(1, pagination.limit);
  }
}, [company]);
  const onSubmit = async (formData) => {
    const payload = {
      ...formData,
      companyId: company.CompanyId,
      credit: type === "credit" ? formData.credit : 0,
      debit: type === "debit" ? formData.debit : 0
    };

    const res = await createCompanyStatement(payload);

    if (res?.status) {
      setShow(false);
      fetchData();
      reset();
    }
  };
const COLUMNS = [
  {
    Header: "S.No",
   Cell: ({ row }) => (
  <span>
    {(pagination.page - 1) * pagination.limit + row.index + 1}
  </span>
),
    width: 60
  },
  {
    Header: "Date",
    accessor: "date",
    Cell: ({ value }) =>
      value ? new Date(value).toLocaleDateString("en-GB") : "---"
  },
  {
    Header: "Particulars",
    accessor: "particulars"
  },
  {
    Header: "Vch No",
    accessor: "VchNo"
  },
  {
    Header: "Vch Type",
    accessor: "VchType"
  },
  {
    Header: "Debit",
    accessor: "debit",
    Cell: ({ value }) => (
      <span className="text-danger">
        {value ? `₹${value}` : "-"}
      </span>
    )
  },
  {
    Header: "Credit",
    accessor: "credit",
    Cell: ({ value }) => (
      <span className="text-success">
        {value ? `₹${value}` : "-"}
      </span>
    )
  },
 {
  Header: "Balance",
  accessor: "balance",
  Cell: ({ value }) => {
    const amount = Number(value || 0);

    return (
      <strong
        className={
          amount < 0
            ? "text-danger"
            : amount > 0
            ? "text-success"
            : "text-dark"
        }
      >
        ₹{amount.toFixed(2)}
      </strong>
    );
  }
},
{
    Header: "Created At",
    accessor: "createdAt",
     Cell: ({ value }) =>
      value ? new Date(value).toLocaleDateString("en-GB") : "---"
  },
];



const getExportData = () => {
  return data.map((item, index) => ({
    "S.No": index + 1,
    Date: item.date
      ? new Date(item.date).toLocaleDateString("en-GB")
      : "",
    Particulars: item.particulars,
    "Vch No": item.VchNo,
    "Vch Type": item.VchType,
    Debit: item.debit || 0,
    Credit: item.credit || 0,
    Balance: item.balance || 0
  }));
};
const site_settings = async () => {
    const res = await site_settingsfindAll();

    if (res?.status) {
        setSiteData(res.data);
    }
};

useEffect(() => {
    site_settings();
}, []);
const getBase64Image = (img) => {
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  return canvas.toDataURL("image/png");
};
const exportToExcel = () => {
  const exportData = getExportData();
   if (!exportData || exportData.length === 0) {
    toast.error("No data to export");
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
  });

  saveAs(file,`${shopNameFromParams} Statement.xlsx`);
};
const exportToCSV = () => {
  const exportData = getExportData();
  if (!exportData || exportData.length === 0) {
    toast.error("No data to export");
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const csv = XLSX.utils.sheet_to_csv(worksheet);

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  saveAs(blob, `${shopNameFromParams}Statement.csv`);
};

const exportToPDF = () => {
  const exportData = getExportData();

  if (!exportData || exportData.length === 0) {
    toast.error("No data to export");
    return;
  }

  const doc = new jsPDF("landscape");

  // LOAD LOGO
  const img = new Image();
  img.src = logo; // your logo path

  img.onload = () => {
    const base64Logo = getBase64Image(img);

    // LOGO
    doc.addImage(base64Logo, "PNG", 14, 8, 20, 20);

    //  LEFT SIDE (SITE INFO)
    doc.setFontSize(16);
    doc.text(siteData?.site_name || "--", 40, 12);

    doc.setFontSize(10);
    doc.text(`Address: ${siteData?.address || "-"}`, 40, 18);
    doc.text(`GST: ${siteData?.GSTNumber || "-"}`, 40, 24);
    doc.text(`Mobile: ${siteData?.contact_us || "-"}`, 40, 30);

    //  RIGHT SIDE (COMPANY INFO)
    doc.setFontSize(14);
    doc.text(
      `A/c Name: ${company?.shopName || "-"}`,
      285,
      10,
      { align: "right" }
    );

    doc.setFontSize(10);
    doc.text(`GST: ${company?.gstin || "-"}`, 285, 16, { align: "right" });
    doc.text(`Mobile: ${company?.shopContact || "-"}`, 285, 22, { align: "right" });

    // TITLE
    doc.setFontSize(14);
    doc.text(
      `Statement - ${company?.shopName || ""}`,
      140,
      40,
      { align: "center" }
    );

    //  TABLE (NO FIELD CHANGE)
    autoTable(doc, {
      startY: 50,
      head: [[
        "S.No",
        "Date",
        "Particulars",
        "Vch No",
        "Vch Type",
        "Debit",
        "Credit",
        "Balance"
      ]],
      body: exportData.map(row => [
        row["S.No"],
        row["Date"],
        row["Particulars"],
        row["Vch No"],
        row["Vch Type"],
        row["Debit"],
        row["Credit"],
        row["Balance"]
      ]),
      styles: { fontSize: 9 }
    });


  

    //  SAVE
    doc.save(`${shopNameFromParams} Statement.pdf`);
  };
};
  return (
    <div className="page-wrapper mt-3">

      {/* HEADER */}
<div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-4 gap-3">

  <h4 className="mb-0 fw-semibold">
    Statement - {shopNameFromParams || company?.shopName}
  </h4>

  <div className="d-flex flex-wrap gap-2">
    <Button size="sm" onClick={() => setShow(true)}>
      <i className="fa fa-plus"></i> Add Statement
    </Button>

    <Button size="sm" variant="success" onClick={exportToExcel}>Excel</Button>
    <Button size="sm" variant="warning" onClick={exportToCSV}>CSV</Button>
    <Button size="sm" variant="danger" onClick={exportToPDF}>PDF</Button>
  </div>

</div>
<div className="row g-2 align-items-center justify-content-between mt-3">

  {/* LEFT SIDE (Rows dropdown) */}
  <div className="col-6 col-md-2">
    <Form.Select
      value={pagination.limit}
      onChange={(e) => handleLimitChange(parseInt(e.target.value))}
    >
      <option value={10}>10 rows</option>
      <option value={25}>25 rows</option>
      <option value={50}>50 rows</option>
      <option value={100}>100 rows</option>
    </Form.Select>
  </div>

  {/* RIGHT SIDE (ALL CONTROLS IN ONE LINE) */}
  <div className="col-12 col-md-10">
    <div className="d-flex flex-wrap gap-2 justify-content-md-end">

      {/* SEARCH */}
      <Form.Control
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ width: "180px" }}
      />

      {/* FROM DATE */}
      <Form.Control
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        style={{ width: "150px" }}
      />

      {/* TO DATE */}
      <Form.Control
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        style={{ width: "150px" }}
      />
<Button
  variant="primary"
  size="sm"
  onClick={() =>
    fetchData(1, pagination.limit, {
      search,
      fromDate,
      toDate
    })
  }
>
  Search
</Button>
      {/* RESET */}
<Button
  variant="secondary"
  size="sm"
  onClick={() => {
    setSearch("");
    setFromDate("");
    setToDate("");

    fetchData(1, pagination.limit, {
      search: "",
      fromDate: "",
      toDate: ""
    });
  }}
>
  Reset
</Button>

      {/* BACK */}
      <Button size="sm" onClick={() => navigate(-1)}>
        Back
      </Button>

    </div>
  </div>

</div>
      {/* TABLE */}
      <Card className="p-3 mt-3">

    

{
  data && data.length > 0 ? (
  <div className="table-responsive">
  <CommonTable
    columns={COLUMNS}
    data={data}
    manualPagination={true}
    pageSize={pagination.limit}
  />
</div>
  ) : (
    <div
      className="d-flex justify-content-center align-items-center"

    >
      <h5 className="text-muted mt-3">No data found</h5>
    </div>
  )
}
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

  <span className="text-center text-md-start">
    Page {paginationData.currentPage} of {paginationData.totalPages}
    <br className="d-md-none"/>
    (Total: {paginationData.totalRecords})
  </span>

  <div className="d-flex flex-wrap gap-1 justify-content-center">
    <Button size="sm"
      disabled={paginationData.currentPage === 1}
      onClick={() => handlePageChange(1)}
    >First</Button>

    <Button size="sm"
      disabled={paginationData.currentPage === 1}
      onClick={() => handlePageChange(paginationData.currentPage - 1)}
    >Prev</Button>

    <Button size="sm"
      disabled={paginationData.currentPage === paginationData.totalPages}
      onClick={() => handlePageChange(paginationData.currentPage + 1)}
    >Next</Button>

    <Button size="sm"
      disabled={paginationData.currentPage === paginationData.totalPages}
      onClick={() => handlePageChange(paginationData.totalPages)}
    >Last</Button>
  </div>

</div>
</Card>
   

      {/* MODAL */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>+ Add Statement</Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Row>

              {/* DATE */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    {...register("date", { required: "Date is required" })}
                  />
                  {errors.date && (
                    <small className="text-danger">{errors.date.message}</small>
                  )}
                </Form.Group>
              </Col>

              {/* REF NO */}
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Vch No <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    placeholder="Enter Vch No"
                    {...register("VchNo")}
                      {...register("VchNo", {
                      required: "Vch No required"
                    })}
                  />
                  
  {errors.VchNo && (
                    <small className="text-danger">
                      {errors.VchNo.message}
                    </small>
                  )}
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Vch Type <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    placeholder="Enter Vch Type"
                    {...register("VchType")}
                      {...register("VchType", {
                      required: "Vch Type required"
                    })}
                  />
                  
  {errors.VchType && (
                    <small className="text-danger">
                      {errors.VchType.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

              {/* PARTICULARS */}
              <Col md={12} className="mt-3">
                <Form.Group>
                  <Form.Label>
                    Particulars <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    placeholder="Enter details"
                    {...register("particulars", {
                      required: "Particulars required"
                    })}
                  />
                  {errors.particulars && (
                    <small className="text-danger">
                      {errors.particulars.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

              {/* TYPE */}
              <Col md={6} className="mt-3">
                <Form.Group>
                  <Form.Label>
                    Transaction Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select {...register("type")}>
                    <option value="debit">Debit</option>
                    <option value="credit">Credit</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* AMOUNT */}
              <Col md={6} className="mt-3">
                <Form.Group>
                  <Form.Label>
                    {type === "debit" ? "Debit Amount" : "Credit Amount"}{" "}
                    <span className="text-danger">*</span>
                  </Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="Enter amount"
                    {...register(type === "debit" ? "debit" : "credit", {
                      required: "Amount required",
                      min: { value: 1, message: "Must be greater than 0" }
                    })}
                  />

                  {(errors.debit || errors.credit) && (
                    <small className="text-danger">
                      {errors.debit?.message || errors.credit?.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cancel
            </Button>

            <Button
              variant="primary"
              type="submit"
              disabled={!watch("date") || !watch("particulars")}
            >
              Save Statement
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </div>
  );
}

export default CreateStatement;